<template>
  <div @mousewheel="rollImg($event)" 
    ref="mapScroll"
    class="distribution-electricity"
    :style="{ zoom: mapZoom + '%' }">
    <div class="bg">
      <div v-for="(text, i) in deviceList" :key="i" class="bg-img">
        <div class="line"></div>
      </div>
    </div>
    <div class="box3">
      <div class="box1">
        <span class="list">用电设备</span>
        <span class="list">通讯状态</span>
        <span class="list">Ua(V)</span>
        <span class="list">Ub(V)</span>
        <span class="list">Uc(V)</span>
        <span class="list">Ia(A)</span>
        <span class="list">Ib(A)</span>
        <span class="list">Ic(A)</span>
        <span class="list">有功功率</span>
        <span class="list">功率因数</span>
        <span class="list">正向有功(Kwh)</span>
        <span class="list">频率(Hz)</span>
      </div>
      <div
        v-for="device in deviceList"
        :key="device.deviceId"
        class="box1 box4"
      >
        <!-- <el-tooltip
          class="item"
          effect="dark"
          :content="device.deviceName"
          :hide-after="0"
          placement="top"
        > -->
          <span :title="device.deviceName" class="list">{{
            device.deviceName.replace(
              /蘭海园|兰海园|1号楼|2号楼|3号楼|4号楼|5号楼/g,
              ""
            )
          }}</span>
        <!-- </el-tooltip> -->
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "10010").length >
          0
            ? (device.monitorList.filter((v) => v.monitorType === "10010")[0]
                .value === 'true' ? '正常' : '离线')
            : "离线"
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "002001").length >
          0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "002001")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "002002").length >
          0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "002002")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "002003").length >
          0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "002003")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "003001").length >
          0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "003001")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "003002").length >
          0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "003002")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "003003").length >
          0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "003003")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "10007").length > 0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "10007")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "10008").length > 0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "10008")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "10009").length > 0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "10009")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
        <span class="list">{{
          device.monitorList.filter((v) => v.monitorType === "006001").length >
          0
            ? parseFloat(
                device.monitorList.filter((v) => v.monitorType === "006001")[0]
                  .value
              ).toFixed(2)
            : ""
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    deviceList: {
      type: Array,
      default: () => []
    },
    textList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      mapZoom: 100,
      minZoom: 50,
      maxZoom: 200,
    }
  },
  created() {

  },
  methods: {
    initMonitorRedisData(monitorList, deviceId) {
      monitorList.map(v => {
        this.findMonitorTypeValue(v.monitorType, monitorList, deviceId);
      })
    },
    findMonitorTypeValue(monitorType, monitorList, deviceId) {
      let monitorObj = monitorList.find((item) => {
        return item.monitorType == monitorType;
      })
      if (+monitorObj.value) {
        this["deviceType" + deviceId]['monitorType' + monitorType] = parseInt(monitorObj.value)
      } else {
        this["deviceType" + deviceId]['monitorType' + monitorType] = monitorObj.value
      }

    },
    //地图放大缩小
    rollImg(event) {
      let zoom = parseInt(this.mapZoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom
            wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动
        */
      let delta = event.wheelDelta
      if (!event.wheelDelta) {
        delta = event.detail
        zoom -= delta / 3 * 10;
      } else {
        zoom += delta / 12;
      }
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (zoom >= this.minZoom && zoom < this.maxZoom) {
        this.mapZoom = zoom;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  overflow: auto;
}
.distribution-electricity {
  background-color: #ffffff;
  min-height: 935px;
  width: 100%;
  border-radius: 5px;
  position: relative;
  text-align: center;
  margin-left: 30px;
}
.bg {
  height: 408px;
  width: 100%;
  display: flex;
  margin-left: 115px;
  .bg-img {
    height: 408px;
    background-image: url("../../../../../assets/beijing_img/icon_3.png");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    .text {
      position: absolute;
      top: 32%;
      left: 45%;
    }
  }
  .line {
    height: 4px;
    width: 115px;
    background-color: #c55a11;
  }
}
.status {
  span {
    width: 60px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    display: block;
    color: #fff;
    background-color: rgb(82, 151, 82);
  }
  .stop {
    background-color: rgb(174, 175, 174);
  }
}
.position1 {
  position: absolute;
  top: 80px;
  left: 130px;
}
.box2 {
  position: absolute;
  display: flex;
  top: 80px;
  left: 760px;
  width: 930px;
  .status {
    margin-right: 33px;
  }
}
.box1 {
  margin-right: 15px;
  .list {
    width: 100px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    display: block;
    font-size: 14px;
    color: #333;
    background-color: #f2f2f2;
    margin-bottom: 8px;
    &:nth-child(odd) {
      background-color: #c9c9c9;
    }
    &:first-child {
      overflow: hidden;
      white-space: nowrap; 
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
}

.box3 {
  position: absolute;
  top: 408px;
  left: 5px;
  display: flex;
}
</style>